/**
 * useHelpAboutItems
 *
 * Returns the static list of items rendered inside the HelpAboutSheet.
 *
 * Flutter source: lib/presentation/screens/settings/app_settings_screen.dart
 * (items section).
 */

import { useLocale } from '@/presentation/contexts/LocaleContext';
import {
  type HelpAboutEntity,
  HelpAboutType,
} from '@/domain/entities/helpAbout/helpAboutEntity';

export const useHelpAboutItems = (): HelpAboutEntity[] => {
  const { l10n } = useLocale();

  return [
    {
      type: HelpAboutType.CONTACT,
      title: l10n.helpAbout.contact,
      description: l10n.helpAbout.contactDescription,
      iconPath: '/assets/images/contact.png',
    },
    {
      type: HelpAboutType.SUPPORT,
      title: l10n.helpAbout.support,
      description: l10n.helpAbout.supportDescription,
      iconPath: '/assets/images/question.png',
    },
    {
      type: HelpAboutType.LEGAL_DOCUMENTS,
      title: l10n.helpAbout.legalDocuments,
      description: l10n.helpAbout.legalDocumentsDescription,
      iconPath: '/assets/images/draft.png',
    },
    {
      type: HelpAboutType.ABOUT,
      title: l10n.helpAbout.about,
      description: l10n.helpAbout.aboutDescription,
      iconPath: '/assets/images/info.png',
    },
  ];
};
